import { Children } from "react";

interface HeaderTemplateProps {
  children: React.ReactNode;
  /**
   * Controls how the center navigation links are aligned inside their space.
   * 'start' = left-aligned, 'center' = middle, 'end' = right-aligned, 'between' = evenly spaced
   */
  centerJustify?: "start" | "center" | "end" | "between";
}

export default function HeaderTemplate({
  children,
  centerJustify = "center",
}: HeaderTemplateProps) {
  // 1. Safely convert children to a flat array to read them by index
  const childrenArray = Children.toArray(children);
  const leftSlot = childrenArray[0];
  const centerSlot = childrenArray[1];
  const rightSlot = childrenArray[2];

  // Map alignment prop to Tailwind utility classes
  const justifyMap = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
  };

  return (
    <div className="flex h-full w-full items-center justify-between py-2 gap-4">
      {/* Index 0: Automatically the Left Slot */}
      {leftSlot && (
        <div className="flex shrink-0 items-center">{leftSlot}</div>
      )}

      {/* Index 1: Automatically the Center Slot */}
      {centerSlot && (
        <div
          className={`flex h-full grow items-center px-2 ${justifyMap[centerJustify]}`}
        >
          {centerSlot}
        </div>
      )}

      {/* Index 2: Automatically the Right Slot */}
      {rightSlot && (
        <div className="flex shrink-0 items-center gap-2">{rightSlot}</div>
      )}
    </div>
  );
}
